import type { Breadcrumb } from "@sentry/react";

// The search (?q=) of a request: it can be a customer's name, so it never reaches Sentry
const SEARCH = /([?&]q=)[^&#]*/g;
// The CEP asked to ViaCEP (viacep.com.br/ws/<CEP>/json/) is where someone lives: never reaches Sentry either
const VIACEP = /(viacep\.com\.br\/ws\/)[^/?#]+/g;
const scrub = (value: unknown) =>
  typeof value === "string" ? value.replace(SEARCH, "$1[Filtered]").replace(VIACEP, "$1[Filtered]") : value;
// "http.query" is the query alone, without the "?"
const scrubQuery = (value: unknown) =>
  typeof value === "string" ? `?${value}`.replace(SEARCH, "$1[Filtered]").slice(1) : value;

/** Sentry's beforeBreadcrumb: a request's (xhr, fetch) address without its search's value nor a CEP; the rest as it is. */
export const scrubBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb | null => {
  if ((breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch") || !breadcrumb.data) return breadcrumb;
  const data = { ...breadcrumb.data };
  if ("url" in data) data.url = scrub(data.url);
  if ("http.query" in data) data["http.query"] = scrubQuery(data["http.query"]);
  return { ...breadcrumb, data };
};
